import React, {Component} from 'react';


export class UserHeader extends Component {
    render() {
        return (
            <header className="section-header">
                <h1 className="section-title">{this.props.name}</h1>
            </header>
        )
    }
}
